<script setup lang="ts">
import { provide } from 'vue'

import {
  dataViewTypeContextInjectionKey,
  dataViewTypeRelationshipsContextInjectionKey,
  useDataViewType,
} from '@/composables/providers/useDataViewType'
import { DataViewType } from '@/constants/relations'

defineSlots<{
  default(): string
}>()

const context = useDataViewType()
provide(dataViewTypeContextInjectionKey, context)

const contextRelationships = useDataViewType(DataViewType.cards)
provide(dataViewTypeRelationshipsContextInjectionKey, contextRelationships)
</script>

<template>
  <slot></slot>
</template>
